var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from 'react';
import { useCitrusUser } from './useCitrusUser';
import { isNotNilOrEmpty } from '@pcty/utils';
import { CitrusTheme } from '../context/CitrusTheme';
/**
 * Gets the theme for a given user
 *
 * @since v1.1.0
 * @returns {Theme} The theme information
 * @example
 * import { useTheme } from '@citrus/user';
 * ...
 * const theme = useTheme();
 */
export var useTheme = function () {
    var _a;
    var theme = useContext(CitrusTheme);
    var user = (_a = useCitrusUser()) === null || _a === void 0 ? void 0 : _a.theme;
    if (isNotNilOrEmpty.all(theme, theme === null || theme === void 0 ? void 0 : theme.name)) {
        return __assign(__assign({}, theme), { darkMode: theme.name === 'legacy' || !theme.darkModeDetection ? false : globalThis.window.matchMedia('(prefers-color-scheme: dark)').matches, citrus2022: theme.name === 'citron' || theme.name === 'citrus2022', legacy: theme.name === 'legacy' });
    }
    if (isNotNilOrEmpty.all(user, user === null || user === void 0 ? void 0 : user.name)) {
        return __assign(__assign({}, user), { darkMode: user.name === 'legacy' || !user.darkModeDetection ? false : globalThis.window.matchMedia('(prefers-color-scheme: dark)').matches, citrus2022: user.name === 'citron' || user.name === 'citrus2022', legacy: user.name === 'legacy' });
    }
    return {
        name: 'legacy',
        darkMode: false,
        darkModeDetection: false,
        citrus2022: false,
        legacy: true,
    };
};
